import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive } from "vue"

const _hoisted_1 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_Login = _resolveComponent("Login")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_overlay = _resolveComponent("v-overlay")!
  const _component_v_app = _resolveComponent("v-app")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_error_alert = _resolveComponent("error-alert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_app, null, {
      default: _withCtx(() => [
        (!_ctx.app.maintenanceMode)
          ? (_openBlock(), _createBlock(_component_v_navigation_drawer, {
              key: 0,
              app: "",
              modelValue: _ctx.drawer.drawer,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.drawer.drawer) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item, {
                      onClick: _ctx.togglePlayStyle,
                      "prepend-icon": _ctx.playStyleIcon,
                      title: "プレースタイル切替"
                    }, null, 8, ["onClick", "prepend-icon"]),
                    _withDirectives(_createVNode(_component_v_list_item, {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.app.loginDialog = true)),
                      "prepend-icon": "mdi-login-variant",
                      title: "ログイン"
                    }, null, 512), [
                      [_vShow, !this.$store.state.auth.user]
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
                      return (_openBlock(), _createBlock(_component_v_list_item, {
                        key: item.name,
                        to: item.path,
                        "prepend-icon": item.meta.icon,
                        title: item.meta.label
                      }, null, 8, ["to", "prepend-icon", "title"]))
                    }), 128)),
                    _withDirectives(_createVNode(_component_v_list_item, {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (this.$store.dispatch('auth/logout').then(() => (_ctx.app.doneLogout = true)))),
                      "prepend-icon": "mdi-logout-variant",
                      title: "ログアウト"
                    }, null, 512), [
                      [_vShow, this.$store.state.auth.user]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        _createVNode(_component_v_app_bar, {
          app: "",
          color: "primary",
          density: "comfortable"
        }, {
          default: _withCtx(() => [
            (!_ctx.app.maintenanceMode)
              ? (_openBlock(), _createBlock(_component_v_app_bar_nav_icon, {
                  key: 0,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.drawer.drawer = !_ctx.drawer.drawer))
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_v_toolbar_title, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.app.title), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_menu, { location: "start" }, {
              activator: _withCtx(({ props }) => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.app.menuIcon, (icon) => {
                  return (_openBlock(), _createBlock(_component_v_btn, {
                    key: icon,
                    onClick: ($event: any) => (icon.fn()),
                    icon: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(icon.icon), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_v_tooltip, {
                        activator: "parent",
                        location: "bottom"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(icon.label), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                }), 128)),
                _withDirectives(_createVNode(_component_v_btn, _mergeProps({ icon: "" }, props), {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                        _createTextVNode("mdi-dots-vertical", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 16), [
                  [_vShow, _ctx.app.menuList.length > 0]
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_v_list, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.app.menuList, (menu) => {
                      return (_openBlock(), _createBlock(_component_v_list_item, { key: menu }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [
                              _createElementVNode("div", {
                                onClick: ($event: any) => (menu.fn()),
                                role: "button"
                              }, _toDisplayString(menu.label), 9, _hoisted_1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_progress_linear, {
          class: "position-fixed",
          style: { top: '56px', 'z-index': 1005 },
          active: _ctx.$store.getters['loading/isLoading'],
          indeterminate: _ctx.$store.getters['loading/isLoading']
        }, null, 8, ["active", "indeterminate"]),
        _createVNode(_component_v_main, null, {
          default: _withCtx(() => [
            _createVNode(_component_router_view, {
              onBarTitle: _ctx.barTitle,
              onBarMenuIcon: _ctx.barMenuIcon,
              onBarMenuList: _ctx.barMenuList,
              onCacheClear: _ctx.cacheClear,
              onLogin: _ctx.login
            }, {
              default: _withCtx(({ Component }) => [
                (_ctx.app.displayKeepAlive)
                  ? (_openBlock(), _createBlock(_KeepAlive, {
                      key: 0,
                      include: []
                    }, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                        key: _ctx.getComponentKey(Component)
                      }))
                    ], 1024))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["onBarTitle", "onBarMenuIcon", "onBarMenuList", "onCacheClear", "onLogin"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_dialog, {
          modelValue: _ctx.app.loginDialog,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.app.loginDialog) = $event)),
          class: "v-col-sm-8 v-col-md-6"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Login)
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_v_overlay, {
          "model-value": _ctx.$store.getters['loading/isOverlayLoading'],
          persistent: "",
          "no-click-animation": "",
          class: "align-center justify-center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_progress_circular, {
              active: _ctx.$store.getters['loading/isOverlayLoading'],
              indeterminate: _ctx.$store.getters['loading/isOverlayLoading'],
              size: "64"
            }, null, 8, ["active", "indeterminate"])
          ]),
          _: 1
        }, 8, ["model-value"])
      ]),
      _: 1
    }),
    _createVNode(_component_v_snackbar, {
      modelValue: _ctx.app.doneLogin,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.app.doneLogin) = $event)),
      timeout: "5000"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.app.doneLoginMessage), 1)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_snackbar, {
      modelValue: _ctx.app.doneLogout,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.app.doneLogout) = $event)),
      timeout: "5000"
    }, {
      default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
        _createTextVNode(" ログアウトしました ", -1)
      ]))]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_snackbar, {
      modelValue: _ctx.app.swUpdated,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.app.swUpdated) = $event)),
      timeout: "-1"
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_v_btn, {
          color: "blue",
          variant: "text",
          onClick: _ctx.reload
        }, {
          default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
            _createTextVNode(" 更新 ", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_v_btn, {
          color: "red",
          variant: "text",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.app.swUpdated = false))
        }, {
          default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
            _createTextVNode(" 閉じる ", -1)
          ]))]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _cache[13] || (_cache[13] = _createTextVNode(" アプリの更新があります。 ", -1))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_error_alert, {
      error: _ctx.app.error,
      handler: _ctx.app.handler,
      type: "snackBar"
    }, null, 8, ["error", "handler"])
  ], 64))
}